import React from 'react'
import Common from '../components/Common'
import AboutUs from '../aboutpage/AboutUs'
import Footer from '../components/Footer';
import Testimonial from '../aboutpage/Testimonial';
export default function About_Us() {
  return (
    <div>
      <Common/>
      <AboutUs/>
      <Testimonial/>
      <Footer/>
    </div>
  )
}
